import { Map, List } from "lucide-react";

type ViewMode = "list" | "map";

interface ViewToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const ViewToggle = ({ viewMode, onViewModeChange }: ViewToggleProps) => {
  return (
    <div className="inline-flex rounded-lg border border-border bg-card p-1">
      <button
        onClick={() => onViewModeChange("list")}
        className={`
          flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors
          ${
            viewMode === "list"
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground hover:bg-muted"
          }
        `}
        aria-pressed={viewMode === "list"}
      >
        <List className="h-4 w-4" />
        Lista
      </button>
      <button
        onClick={() => onViewModeChange("map")}
        className={`
          flex items-center gap-1.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors
          ${
            viewMode === "map"
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground hover:bg-muted"
          }
        `}
        aria-pressed={viewMode === "map"}
      >
        <Map className="h-4 w-4" />
        Karta
      </button>
    </div>
  );
};

export default ViewToggle;
